import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  const isArabicLayout = theme.direction === "rtl";

  return {
    wrapperAutocomplete: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      width: "100%",
    },
    errorBorder: {
      borderColor: theme.palette.border.error + " !important",
    },
    errorMessage: {
      color: theme.palette.error.main,
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 400,
    },
    autoCompleteWrapper: {
      width: "100%",
      "& .MuiAutocomplete-endAdornment": {
        top: "25%",
        right: isArabicLayout ? "unset !important" : "14px !important",
        left: isArabicLayout ? "14px !important" : "unset",
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        cursor: "pointer",
        width: "100%",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.border.primary,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.border.primary,
      },
      "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
        {
          borderColor: `${theme.palette.border.primary} !important`,
        },
    },
    withDefaultPadding: {
      "& .MuiAutocomplete-inputRoot": {
        padding: "10px 14px !important",
      },
    },
    noPadding: {
      "& .MuiAutocomplete-inputRoot": {
        padding: "0 !important",
      },
    },
    placeholder: {
      fontWeight: 400,
      cursor: "pointer",
      "&::placeholder": {
        color: theme.palette.text.placeholder,
        opacity: "1 !important", // Ensure the opacity is solid
      },
    },
    selected: {
      fontWeight: 500,
    },
    dropdownIcon: {
      cursor: "pointer",
      color: theme.palette.foreground.quarterary,
      fontSize: "20px",
    },
    inputIcon: {
      marginRight: theme.spacing(1),
      color: theme.palette.foreground.quarterary,
    },
    iconVariant: {
      "& .MuiOutlinedInput-root": {
        paddingLeft: theme.spacing(3),
      },
    },
    noBorder: {
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    },
    option: {
      padding: "0 16px",
    },
    customOption: {
      '&.MuiAutocomplete-option[data-focus="true"]': {
        backgroundColor: `${theme.palette.background.primary_hover} !important`,
      },
    },
    listBox: {
      display: "flex",
      gap: "10px",
      flexDirection: "column",
    },
    paper: {
      borderRadius: "8px",
      border: `1px solid ${theme.palette.border.secondary}`,
      background: theme.palette.background.paper,
      boxShadow:
        "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    },
    renderOptionsWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
    },
    multipleWrapper: {
      "& .MuiAutocomplete-inputRoot": {
        flexWrap: "wrap",
      },
      "& .MuiInputBase-input": {
        width: "initial",
        display: "inline-flex",
      },
    },
    customChipWrapper: {
      borderRadius: "6px",
      border: `1px solid ${theme.palette.border.primary}`,
      background: theme.palette.background.paper,
      display: "flex",
      padding: "2px 4px 2px 5px",
      justifyContent: "center",
      alignItems: "center",
      gap: "3px",
      minHeight: "24px",
    },
    customChipContent: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
    },
    customChipLabel: {
      color: theme.palette.text.secondary,
      textAlign: "center",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "20px",
    },
    iconWrapper: {
      width: "16px",
      height: "16px",
      borderRadius: "9999px",
    },
    chipsContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "5px",
    },
    closeXIcon: {
      cursor: "pointer",
    },
    truncatedInput: {
      "& .MuiAutocomplete-input": {
        maxWidth: "calc(100% - 60px)",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
  };
});
